/* eslint-disable react/prop-types */
import React, { memo, useMemo } from 'react';
import {
  StyleSheet,
  View,
  TouchableOpacity,
  TextInput,
  Dimensions,
} from 'react-native';
import { QText } from '../components';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'react-native-paper';

const { width } = Dimensions.get('window');
const SelectableButtonList = ({
  dataList,
  selectedValue,
  onSelect,
  changeText,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  return (
    <View style={styles.paidOptionsView}>
      {dataList.map((rate, index) => {
        return (
          <TouchableOpacity
            style={[
              styles.paidOption,
              {
                borderColor:
                  selectedValue.isCustom === false &&
                  rate == selectedValue.value
                    ? theme.colors.primary
                    : theme.colors.borderColor,
                borderWidth:
                  selectedValue.isCustom === false &&
                  rate == selectedValue.value
                    ? 2
                    : 1,
              },
            ]}
            key={index}
            onPress={() => {
              onSelect(rate);
            }}
          >
            <QText>{t(rate)}</QText>
          </TouchableOpacity>
        );
      })}
      <View style={styles.paidOption}>
        <TextInput
          keyboardType={'numeric'}
          label={t('enter')}
          onFocus={() => changeText('')}
          value={selectedValue.isCustom ? selectedValue.value : ''}
          onChangeText={(text) => changeText(text)}
          style={{
            width: width >= 350 ? 70 : 60,
            height: 42,
            borderRadius: 8,
            padding: 10,
            backgroundColor: theme.colors.onBackground,
            fontSize: 13,
            color: theme.colors.text,
            borderWidth: 1,
            borderColor: selectedValue.isCustom
              ? theme.colors.primary
              : theme.colors.borderColor,
            fontFamily: 'Poppins',
            outlineStyle: 'none',
            textAlign: 'center',
          }}
          placeholder={t('enter')}
          placeholderTextColor={theme.colors.placeHolderText}
        />
      </View>
    </View>
  );
};

const createStyles = (theme) =>
  StyleSheet.create({
    // eslint-disable-next-line react-native/no-unused-styles
    paidOptionsView: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    // eslint-disable-next-line react-native/no-unused-styles
    paidOption: {
      backgroundColor: theme.colors.onBackground,
      borderRadius: 8,
      width: width >= 350 ? 70 : 60,
      height: 44,
      justifyContent: 'center',
      alignItems: 'center',
      textAlignVertical: 'top',
    },
  });

export default memo(SelectableButtonList);
